import { render, staticRenderFns } from "./EditProjectDialog.vue?vue&type=template&id=37aa83f8&scoped=true&"
import script from "./EditProjectDialog.vue?vue&type=script&lang=js&"
export * from "./EditProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectDialog.vue?vue&type=style&index=0&id=37aa83f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa83f8",
  null
  
)

export default component.exports